/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'

import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
import { mdiChevronLeft, mdiChevronRight } from "@mdi/js"
import { useI18n } from 'vue-i18n'
import i18n from '@/plugins/i18n'
import { createVueI18nAdapter } from 'vuetify/locale/adapters/vue-i18n'

// Landing-page palette, sampled from the approved mockup.
const landingColors = {
  cream: '#FCF6E8',
  mint: '#EDF6E5',
  paper: '#FCFBF5',
  forest: '#0F4827',
  sage: '#DCECDA',
  band: '#0D5731',
}

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
  locale: {
    adapter: createVueI18nAdapter({ i18n, useI18n }),
    rtl: { ar: true },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: { colors: { primary: '#1b5e20', ...landingColors } },
      dark: { colors: { primary: '#1b5e20', ...landingColors } },
    },
  },
  icons: {
    defaultSet: "mdi",
    aliases: {
      ...aliases,
      // prev: mdiChevronRight,
      // next: mdiChevronLeft,
    },
    sets: {
      mdi,
    },
  },

})
